module.exports = __webpack_public_path__ + "static/media/PM71.4006f02e.png";